import { multipleSelect } from './multiple-select.js';
import './multiple-select.css';
import './multiple-select.custom.css';

class MultipleSelect extends HTMLElement {
    static get observedAttributes () {
        return ['options'];
    }

    constructor() {
        super();
        this.options = JSON.parse(this.getAttribute('options'));
        this.single = this.hasAttribute('single');
        this.render();
    }

    attributeChangedCallback (name, oldValue, newValue) {
        switch (name) {
            case 'options':
                this.options = JSON.parse(newValue);
                break;
            case 'single':
                this.single = newValue;
                break;
        }
        this.render();
    }

    resetValues () {
        this.selectControl.setSelects([]);
    };

    render () {
        const id = this.title.replace(/\s+/g, "");
        this.innerHTML = `
            <label><strong>${this.title}</strong></label>
            <div class="multi-select">
            <select ${!this.single ? 'multiple="multiple"' : ''}  id="${id}" class="multiple-select" placeholder="All">
                ${this.options.map(o => `<option value="${o.value}" ${o.selected ? 'selected' : ''}>${o.text}</option>`).join('')}
            </select>
            </div>
        `;
        this.selectControl = multipleSelect(`#${id}`, {
            name: id,
            single: this.single,
            useSelectOptionLabelToHtml: true,
        });

        this.querySelector('select').addEventListener('change', () => {
            this.closest('product-shop').submitForm();
            this.selectControl.close();
        });
    }
}

customElements.define('multi-select', MultipleSelect);